import React from 'react';

const FlexSpace: React.FC = () => {
    return <div style={{ flex: 1 }}/>;
}

export default FlexSpace;